var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDiners = function SvgDiners(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 40,
    viewBox: "0 0 50 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 20.5051C50 8.7736 40.1315 0.664694 29.3192 0.668588H20.0142C9.07263 0.664694 0.0666809 8.77607 0.0666809 20.5051C0.0666809 31.2354 9.07287 40.0515 20.0142 39.9998H29.3192C40.1311 40.0513 50 31.2329 50 20.5051Z",
    fill: "#0079BE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0718 2.33067C10.0738 2.33374 1.97201 10.3913 1.96939 20.3358C1.97189 30.2786 10.0736 38.3352 20.0718 38.3384C30.0721 38.3353 38.1759 30.2786 38.177 20.3358C38.1756 10.3911 30.0721 2.33374 20.0718 2.33067Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.62927 20.2869C8.63879 15.4275 11.6913 11.2837 15.9956 9.63703V30.9343C11.6913 29.2886 8.63867 25.1469 8.62927 20.2869ZM24.2086 30.9398V9.63703C28.5147 11.2798 31.572 15.426 31.5798 20.2876C31.572 25.1508 28.5147 29.2939 24.2086 30.9398Z",
    fill: "#0079BE"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDiners);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/diners.e6fa928f5571b73c74ae93731a3968e2.svg";